var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { useModalContext } from '../context';
/**
 * # Modal.Actions
 *
 * 모달의 버튼 액션 그룹 영역입니다.
 *
 * @example ```tsx
 * <Modal.Actions>This is a modal</Modal.Actions>
 * ```
 */
var Actions = function (props) {
    var children = useModalContext(props).children;
    return <Footer>{children}</Footer>;
};
var Footer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  position: sticky;\n  bottom: 0;\n  border-top: 1px solid ", ";\n  border-bottom-right-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n  overflow: hidden;\n"], ["\n  display: flex;\n  position: sticky;\n  bottom: 0;\n  border-top: 1px solid ", ";\n  border-bottom-right-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n  overflow: hidden;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.PRIMARY.ACCENT_2;
});
export { Actions };
var templateObject_1;
//# sourceMappingURL=Actions.jsx.map